// Must be webpack's FIRST entry so this runs before any async chunk is
// requested. Reads __WINEM8_ENV injected by the server template (see
// templates/PageContainer.tsx) and sets webpack's runtime publicPath, so the
// same bundle works in any shop / any appProxyPath.
declare let __webpack_public_path__: string;

const env =
    (typeof window !== 'undefined' && (window as any).__WINEM8_ENV) || {};

if (env.WINEM8_CHECKOUT_PATH) {
    __webpack_public_path__ = `${env.WINEM8_CHECKOUT_PATH}/`;
}

export {};
